module.exports = __webpack_public_path__ + "img/icon-close.6cf0f2f3.svg";